<template>
  <main>
    <!-- Navbar -->
    <header class="bg-white shadow-md fixed w-full top-0 z-50">
      <nav class="container mx-auto px-6 py-4">
        <div class="flex justify-between items-center">
          <div class="text-2xl font-bold text-blue-800">
            <router-link to="/" >Keene Engineering Consultants</router-link>
          </div>
          <div class="hidden md:flex space-x-8">
            <router-link to="/" class="block text-gray-700 hover:text-blue-800">Home</router-link>
            <router-link to="/projects" class="block text-gray-700 hover:text-blue-800">Projects</router-link>
            <router-link to="/services" class="block text-gray-700 hover:text-blue-800">Services</router-link>
            <router-link to="/about" class="block text-gray-700 hover:text-blue-800">About</router-link>
            <router-link to="/contact" class="block text-gray-700 hover:text-blue-800">Contact</router-link>
          </div>
          <!-- Mobile Menu Button -->
          <button class="md:hidden text-gray-700" @click="toggleMobileMenu">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
          </button>
        </div>
        <!-- Mobile Menu -->
        <div v-if="isMobileMenuOpen" class="md:hidden mt-4 space-y-4">
          <router-link to="/" class="block text-gray-700 hover:text-blue-800">Home</router-link>
          <router-link to="/projects" class="block text-gray-700 hover:text-blue-800">Projects</router-link>
          <router-link to="/services" class="block text-gray-700 hover:text-blue-800">Services</router-link>
          <router-link to="/about" class="block text-gray-700 hover:text-blue-800">About</router-link>
          <router-link to="/contact" class="block text-gray-700 hover:text-blue-800">Contact</router-link>
        </div>
      </nav>
    </header>

    <main class="flex-grow">
      <slot></slot>
    </main>
    <!-- Contact Info Section -->
    <section class="bg-blue-800 text-white py-12">
      <div class="container mx-auto px-6">
        <div class="grid md:grid-cols-3 gap-8 text-center">
          <div>
            <h4 class="font-bold mb-2">Contact Us</h4>
            <p>(555) 123-4567</p>
          </div>
          <div>
            <h4 class="font-bold mb-2">Email</h4>
            <p>info@keeneengineering.com</p>
          </div>
          <div>
            <h4 class="font-bold mb-2">Address</h4>
            <p>123 Engineering Way, Suite 100<br/>City, State 12345</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-gray-900 text-white py-8">
      <div class="container mx-auto px-6">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <div class="mb-4 md:mb-0">
            <p>&copy; 2024 Keene Engineering Consultants. All rights reserved.</p>
          </div>
          <div class="flex space-x-4">
            <router-link to="/faq" class="hover:text-blue-400">FAQs</router-link>
            <!-- Dynamically Render Site Pages -->
            <router-link
              v-for="page in pages"
              :key="page.slug.current"
              :to="`/site/${page.slug.current}`"
              class="hover:text-blue-400"
            >
              {{ page.title }}
            </router-link>
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>

<script setup>
import { ref } from "vue";
import { onMounted } from 'vue';
import { useSitePage } from '@/composables/useSitePage';

const isMobileMenuOpen = ref(false)
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const { pages, fetchAllPages } = useSitePage();

onMounted(() => {
  fetchAllPages();
});
</script>
